import { render, staticRenderFns } from "./SeventhPage.vue?vue&type=template&id=49dfda6a&scoped=true&"
import script from "./SeventhPage.vue?vue&type=script&lang=js&"
export * from "./SeventhPage.vue?vue&type=script&lang=js&"
import style0 from "./SeventhPage.vue?vue&type=style&index=0&id=49dfda6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dfda6a",
  null
  
)

export default component.exports